<template>
    <div>
        <div id="shipping_form">
            <text-input
                inputId="shipping_firstname"
                v-model="shippingAddress.firstname"
                :inputMaxLength="60"
                :addClass="customClass"
                :inputLbl="lblShipping.firstname"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="isShowErrorLbl"
                :errorInfo="arrErrorInfo[0]"
                :isTextOnly="true"
                ></text-input>
            <text-input
                inputId="shipping_lastname"
                v-model="shippingAddress.lastname"
                :inputMaxLength="60"
                :addClass="customClass"
                :inputLbl="lblShipping.lastname"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="isShowErrorLbl"
                :errorInfo="arrErrorInfo[1]"
                :isTextOnly="true"
            ></text-input>
            <contact-number-input
                inputId="shipping_contact_number"
                v-model="shippingAddress.contact_number"
                :delimeter="'-'"
                :addClass="customClass"
                :inputLbl="lblShipping.contactnumber"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="isShowErrorLbl"
                :errorInfo="arrErrorInfo[2]"
                ></contact-number-input>
            <address-input
                inputId="shipping_address"
                v-model="shippingAddress.address"
                :inputMaxLength="100"
                :addClass="customClass"
                :inputLbl="lblShipping.address"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="isShowErrorLbl"
                :errorInfo="arrErrorInfo[3]"
                ></address-input>
            <form-address-dropdown
                :addClass="customClass"
                :address="shippingAddress"
                formId="shipping"
                :lblShipping="lblShipping"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="isShowErrorLbl"
                :zipcodeError="arrErrorInfo[4]"
                :subDistrictError="arrErrorInfo[5]"
                :districtError="arrErrorInfo[6]"
                :provinceError="arrErrorInfo[7]"
                ></form-address-dropdown>
        </div>
        <div id="save_btn" class="btn-wrapper">
            <div class="btn-txt"
                @click="clickSave">{{lblShipping.save_address_btn}}</div>
        </div>
    </div>
</template>
<script>
//component
import TextInput from "@/components/Input/Text.vue";
import AddressInput from "@/components/Input/AddressInput.vue";
import ContactNumberInput from "@/components/Input/ContactNumber.vue";
import FormAddressDropdown from "@/components/Form/FormAddressDropDown.vue";
export default {
    name: 'shipping-address',
    components: {
        TextInput,
        AddressInput,
        ContactNumberInput,
        FormAddressDropdown
    },
    props: {
        lblShipping: Object,
        page: String,

        shippingAddress: Object,

        busAddress: Object
    },
    data: function () {
        return {
            customClass: 'shipping-input',

            isValid: true,
            errMsg: '',

            arrErrorInfo: [],
            isFirstSave: true,
            isShowErrorLbl: true,
        };
    },
    created: function () {
        for(var i = 0;i < 9; i++) {
            this.arrErrorInfo.push({
                isValid: true,
                msg: '',
            });
        }
    },
    methods: {
        //event
        clickSave: function () {
            this.isFirstSave = false;
            this.validateForm();

            if (this.isValid) {
                this.busAddress.$emit('clickSave');
            }
        },
        //method
        validateForm: function () {
            this.isValid = true;
            this.errMsg = '';
            //Check validate result and update.
            for(var error of this.arrErrorInfo) {
                if(!error.isValid) {
                    this.isValid = false;
                    this.errMsg = error.msg;

                    return;
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    #shipping_address_header {
        font-size: 1.5rem;
        line-height: 1;
    }

    #save_btn {
        margin-bottom: 15px;
    }
</style>
<style lang="scss">
@import "@/style/base/common.scss";
.shipping-input {
    @include baseRegisterInput;
    margin-bottom: 20px;

    &.shipping-zipcode {
        .input-wrapper {
            input {
                padding-left: 140px;
            }

            .input-lbl {
                width: 130px;
            }
        }
    }
}
</style>
